import baseUrl from './baseUrl'

export default {
  action: {
    read: 'read',
    permissionLogin: 'allow',
  },

  resource: {
    auth: 'Auth',
    user: 'debtor',
  },

  // BASEURL
  baseUrl: baseUrl.ApiBaseUrl,
  baseUrlV2: baseUrl.ApiBaseUrlV2,
  serverBaseUrl: baseUrl.serverBaseUrl,
  debtiaappUrl: baseUrl.debtiaappUrl,
  paymentsBaseUrl: baseUrl.paymentsBaseUrl,
  communicationBaseUrlV1: baseUrl.communicationBaseUrlV1,
  clientID: baseUrl.clientID,
  secret: baseUrl.secret,
  debtiaappClientID: baseUrl.debtiaappClientID,
  debtiaappSecret: baseUrl.debtiaappSecret,
}
